// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-popup h3 {
  font-size: 2.2rem;
}
.confirmation-popup p {
  margin-top: -2rem;
}
.confirmation-popup .buttons {
  display: flex;
  margin-top: 5rem;
  justify-content: space-evenly;
  align-items: center;
}
.confirmation-popup .buttons .button-component {
  display: flex;
}
.confirmation-popup .buttons .button-component:first-child {
  justify-content: start;
}
.confirmation-popup .buttons .button-component {
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/OverclaimConfirmationPopup/index.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAIM;EACE,sBAAA;AAFR;AAFI;EAOE,oBAAA;AAFN","sourcesContent":[".confirmation-popup {\n  h3 {\n    font-size: 2.2rem;\n  }\n\n  p {\n    margin-top: -2rem;\n  }\n\n  .buttons {\n    display: flex;\n    margin-top: 5rem;\n    justify-content: space-evenly;\n    align-items: center;\n\n    .button-component {\n      display: flex;\n\n      &:first-child {\n        justify-content: start;\n      }\n\n      justify-content: end;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
